import { defineQueries } from '@rocicorp/zero';
import { organisations } from './organisation.queries.js';
import { organisationUsers } from './organisation-user.queries.js';
export { ListOrganisationsInput } from './organisation.queries.js';
export { ListOrganisationUsersInput } from './organisation-user.queries.js';
export const queries = defineQueries({
    organisations,
    organisationUsers,
});
//# sourceMappingURL=index.js.map